import * as Yup from 'yup';

export default Yup;
